import React from "react";
import Dashboard from "../Dashboard/Dashboard";
import PlanManagementListing from "../../Sections/PlanManagement";

const PlanManagementComponent = () => {
  return <Dashboard sectionName={<PlanManagementListing />} />;
};

export default PlanManagementComponent;
